<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/customer-task' }">客户任务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="parentPage">客户项目管理({{customer.name}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="dataModel"
               :rules="formRules"
               label-width="160px">

        <el-collapse v-model="activeNames">
          <el-collapse-item title="项目基本信息" name="1">

            <el-form-item prop="name"
                          label="项目名称:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.name"
                          :disabled="true"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="number"
                          label="项目编号:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.number"
                          maxlength="50"
                          :disabled="type === 'view'"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="execute_rate"
                          label="执行频次:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.execute_rate"
                          :disabled="true"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="BD"
                          prop="bd">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  :disabled="true"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.bd"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="BO"
                          prop="bu">
              <el-col :span="inputWith">
                <remote-select
                  class="width-max"
                  :disabled="true"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入管理员名称搜索"
                  v-model="dataModel.bu"
                  :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                  :find-request="getRemoteSelectAdminUsers">
                </remote-select>
              </el-col>
            </el-form-item>

            <el-form-item label="申请人"
                          prop="creator">
              <span>{{ initiator_name }}</span>
            </el-form-item>

            <el-form-item label="项目等级"
                          prop="project_level">
              <el-col :span="inputWith">
                <el-select class="width-max"
                          :disabled="true"
                           v-model="dataModel.project_level"
                           placeholder="请选择">
                  <el-option
                    v-for="item in opts.projectLevel"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item prop="project_category"
                          label="项目分类:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.project_category"
                          :disabled="true"
                          maxlength="50"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="target_complete_rate"
                          label="目标完成率:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="dataModel.target_complete_rate"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="target_market_num"
                          label="目标门店数:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="dataModel.target_market_num"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="starttime"
                          label="开始时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dataModel.starttime"
                :disabled="true"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="endtime"
                          label="结束时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dataModel.endtime"
                :disabled="true"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="任务发布通知"
                          prop="enable_release_notice">
              <el-col :span="inputWith">
                <el-switch v-model="dataModel.enable_release_notice"
                           :disabled="type === 'view'"
                           active-value="1"
                           inactive-value="0"
                           active-text="开启"
                           inactive-text="关闭"
                           active-color="#13ce66"
                           inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-form-item>
            <el-form-item label="APP首页是否展示任务包:"
                          class="app-task-package-view-item"
                          prop="app_task_package_display">
              <el-tag size="small"
                      :type="getDisplayStatusTagType(dataModel.app_task_package_display)">
                {{ getDisplayFormLabel(dataModel.app_task_package_display) }}
              </el-tag>
            </el-form-item>
            <el-form-item v-if="isDisplayEnabled(dataModel.app_task_package_display)"
                          class="app-task-package-view-item"
                          label="首页任务包名称:"
                          prop="app_task_package_title">
              <span class="app-task-package-view-text">{{ dataModel.app_task_package_title || '-' }}</span>
            </el-form-item>
            <el-form-item v-if="isDisplayPartial(dataModel.app_task_package_display)"
                          class="app-task-package-view-item"
                          label="白名单标签/标签组:"
                          prop="app_task_package_whitelist_tags">
              <div v-if="appTaskPackageWhitelistTagNameList.length"
                   class="app-task-package-view-tags">
                <el-tag v-for="(name, idx) in appTaskPackageWhitelistTagNameList"
                        :key="'wl-' + idx"
                        size="mini"
                        type="info"
                        class="app-task-package-view-tag">{{ name }}</el-tag>
              </div>
              <span v-else
                    class="app-task-package-view-text is-muted">-</span>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="财务信息" name="2">

            <el-form-item label="服务类型"
                          prop="distribute_type">
              <el-col :span="inputWith">
                <el-select class="width-max"
                          :disabled="true"
                           v-model="dataModel.distribute_type"
                           placeholder="请选择">
                  <el-option
                    v-for="item in opts.distributeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="审单归属"
                          prop="review_group">
              <el-col :span="inputWith">
                <el-select class="width-max"
                          :disabled="true"
                           v-model="dataModel.review_group"
                           placeholder="请选择">
                  <el-option
                    v-for="item in opts.reviewGroup"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <!--预算类状态审批通过后是无法在此修改的-->
            <el-form-item prop="predict_frontend_cost"
                          label="前端预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                 <span>
                    {{dataModel.predict_frontend_cost | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>

            <el-form-item prop="predict_label_cost"
                          label="标注预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <span>
                    {{dataModel.predict_label_cost | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>

            <el-form-item prop="predict_backend_cost"
                          label="后端预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <span>
                    {{dataModel.predict_backend_cost | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>

            <el-form-item prop="predict_others_cost"
                          label="其他预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                  <span>
                    {{dataModel.predict_others_cost | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>


            <el-form-item prop="total_cost"
                          label="项目总预算:">
              <el-col :span="inputWith"
                      style="width: 260px">
                 <span>
                    {{totalCost | seperateThousandsToFixed(2)}}元
                </span>

              </el-col>
            </el-form-item>


            <el-form-item prop="ticket_predict"
                          label="预估开票金额(未税):">
              <el-col :span="inputWith"
                      style="width: 260px">
                 <span>
                    {{dataModel.ticket_predict | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>


            <el-form-item prop="gross_rate_predict"
                          label="预估毛利率:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="grossRatePredit"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>


            <el-form-item prop="executive_budget"
                          label="预估执行成本:">
              <el-col :span="inputWith">
                  <span>
                    {{dataModel.executive_budget | seperateThousandsToFixed(2)}}元
                </span>
              </el-col>
            </el-form-item>

          </el-collapse-item>
          <el-collapse-item title="合规情况" name="3">
            <el-form-item label="项目初次执行"
                          prop="is_first_execute">
              <el-radio-group v-model="dataModel.is_first_execute"
                              :disabled="true">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="商务流程完备"
                          prop="business_process_completed">
              <el-radio-group v-model="dataModel.business_process_completed"
                              :disabled="true">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item prop="annual_cooperation_scale"
                          label="年度合作规模:">
              <el-col :span="inputWith"
                      style="width: 260px">
                   <span>
                    {{dataModel.annual_cooperation_scale | seperateThousandsToFixed(2)}}万元
                </span>
              </el-col>
            </el-form-item>

            <el-form-item prop="annual_cooperation_times"
                          label="全年合作次数:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model="dataModel.annual_cooperation_times"
                          :disabled="true"
                          maxlength="20"
                          clearable>
                  <template slot="append">次</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="contract_no"
                          label="所属合同编号:"
                          v-if="dataModel.business_process_completed">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.contract_no"
                          :disabled="true"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <el-form-item prop="type"
                          label="项目类型:">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-select v-model="dataModel.type"
                           :disabled="true"
                           clearable>
                  <el-option v-for="item in opts.type"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item prop="detail"
                          label="项目备注:">
              <el-col :span="inputWith">
                <el-input v-model="dataModel.detail"
                          :disabled="true"
                          clearable></el-input>
              </el-col>
            </el-form-item>

            <div v-if="type === 'view'">
              <el-form-item label="BO审核"
                            prop="bu_approver">
                <el-col :span="inputWith">
                  <remote-select
                    v-if="dataModel.bu_approver > 0"
                    class="width-max"
                    :disabled="true"
                    clearable
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入管理员名称搜索"
                    v-model="dataModel.bu_approver"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                    :find-request="getRemoteSelectAdminUsers">
                  </remote-select>
                  <span v-else>未指定BO审核人</span>
                </el-col>
              </el-form-item>


              <el-form-item label="一级审核"
                            prop="first_approver">
                <el-col :span="inputWith">
                  <remote-select
                    class="width-max"
                    :disabled="true"
                    clearable
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入管理员名称搜索"
                    v-model="dataModel.first_approver"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                    :find-request="getRemoteSelectAdminUsers">
                  </remote-select>
                </el-col>
              </el-form-item>

              <el-form-item label="二级审核"
                            prop="second_approver">
                <el-col :span="inputWith">
                  <remote-select
                    class="width-max"
                    :disabled="true"
                    clearable
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入管理员名称搜索"
                    v-model="dataModel.second_approver"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                    :find-request="getRemoteSelectAdminUsers">
                  </remote-select>
                </el-col>
              </el-form-item>

              <el-form-item label="财务审核"
                            prop="finance_approver">
                <el-col :span="inputWith">
                  <remote-select
                    class="width-max"
                    :disabled="true"
                    clearable
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入管理员名称搜索"
                    v-model="dataModel.finance_approver"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                    :find-request="getRemoteSelectAdminUsers">
                  </remote-select>
                </el-col>
              </el-form-item>

              <el-form-item label="收件人"
                            prop="receiver">
                <el-col :span="inputWith">
                  <remote-select
                    class="width-max"
                    :disabled="true"
                    clearable
                    multiple
                    :multiple-limit=multipleLimit
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入管理员名称搜索"
                    v-model="dataModel.receiver"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                    :find-request="getRemoteSelectAdminUsers">
                  </remote-select>
                </el-col>
              </el-form-item>
            </div>

          </el-collapse-item>
        </el-collapse>
      </el-form>


      <el-form ref="SubForm"
               :model="dataModel"
               :rules="formRules"
               label-width="120px">

      <el-form-item label="附件" prop="attached_file">
        <el-upload
          class="upload-demo"
          action=""
          multiple
          :auto-upload="false"
          :on-change="function (res, file) {return onChangeFile(res, file) }"
          :before-remove="function (res, file) {return beforeRemove(res, file) }"
          :limit="limit"
          :on-exceed="handleExceed"
          :file-list="fileList"
          accept=".jpg, .jpeg, .xlsx, .pdf, .eml"
          ref="upload"
          v-if="isNeedBoAudit"
        >
          <el-button size="small"
                     type="primary">点击上传
          </el-button>
          <div slot="tip"
               class="el-upload__tip">只能上传jpg,xlsx,pdf,eml文件
          </div>
        </el-upload>
        <template>
          <div class="view-navbar">
            <ul class="clear-both">
              <li v-for="(item, index) in dataModel.attached_file">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                  <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.url" @click="onViewImage">
                  <i v-if="item.type !== 'pic'"
                     class="sj-icon-pdf"
                     style=" font-size:100px; margin-top: 50px"
                     @click="onGetPdfFile(item, index)"></i>
                </el-tooltip>
              </li>
            </ul>

          </div>
        </template>
      </el-form-item>

        <div v-if="type !== 'view'">
          <el-form-item prop="special_approve_reason"
                        label="特批说明:">
            <el-col :span="inputWith">
              <el-input v-model="dataModel.special_approve_reason"
                        :disabled="!isNeedBoAudit"
                        clearable></el-input>
            </el-col>
          </el-form-item>

          <el-form-item prop="reason"
                        label="驳回理由:">
            <el-col :span="inputWith">
              <el-input v-model="reason"
                        clearable></el-input>
            </el-col>
          </el-form-item>


          <el-button type="primary"
                     size="mini"
                     @click="pass">通过
          </el-button>

          <el-button type="primary"
                     size="mini"
                     @click="reject">驳回
          </el-button>
        </div>
      </el-form>
      <attached-file :visible="attach_file_visible"
                     :file_title="file_title"
                     :url="attach_file_url"
                     @closeDialog="attach_file_visible=false"></attached-file>
    </layout-panel>
  </div>
</template>


<script>
import { formRules } from '../customer-project.rules'
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from 'downloadjs'
import AttachedFile from '@/views/payment-manager/components/AttachedFile'
import {
  consts as taskPackageConsts,
  isDisplayEnabled,
  isDisplayPartial,
  getDisplayFormLabel,
  getDisplayStatusTagType,
} from '@views/project-task-package/project-task-package.constants'

export default {
  components: {
    AttachedFile,
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onLoad()
      vm.setPreviousTable(from)
    })
  },
  computed: {
    ...Vuex.mapState({
      opts: state => state.customerProject,
      statusEnum: state => state.customerProjectcost.statusEnum,
    }),
    appTaskPackageWhitelistTagNames () {
      return this.appTaskPackageWhitelistTagLabel || (this.dataModel.app_task_package_whitelist_tags || []).join(', ')
    },
    appTaskPackageWhitelistTagNameList () {
      if (this.appTaskPackageWhitelistTagLabel) {
        return this.appTaskPackageWhitelistTagLabel.split('、').filter(Boolean)
      }
      return (this.dataModel.app_task_package_whitelist_tags || []).map(String).filter(Boolean)
    },
    totalCost: {
      get () {
        let cost = parseFloat(this.dataModel.predict_frontend_cost) + parseFloat(this.dataModel.predict_label_cost) + parseFloat(this.dataModel.predict_backend_cost) + parseFloat(this.dataModel.predict_others_cost)
        return cost
      }
    },
    isNeedBoAudit: {
      get () {
        return this.dataModel.status * 1 === this.statusEnum.REVIEW
      }
    },
    // 毛利率=（预估开票-预估成本）/预估开票
    grossRatePredit: {
      get () {
        let rate = _.round(((parseFloat(this.dataModel.ticket_predict) - parseFloat(this.totalCost)) / parseFloat(this.dataModel.ticket_predict) * 100), 2)
        this.dataModel.gross_rate_predict = rate
        return rate
      },
    }
  },
  watch: {
    'dataModel.predict_frontend_cost' () {
      if (!this.id) {
        this.dataModel.executive_budget = _.round(this.dataModel.predict_frontend_cost * 0.05, 2)
      }
    }
  },
  data () {
    formRules.endtime.push({validator: this.endtimeValidator, trigger: 'blur'})
    return {
      isDisplayEnabled,
      isDisplayPartial,
      getDisplayFormLabel,
      getDisplayStatusTagType,
      multipleLimit: 30,
      limit: 10,
      inputWith: 12,
      id: this.$route.params.id,
      type: this.$route.query.type || null,
      customer: {
        id: null,
        name: null
      },
      parentPage: {
        name: '客户项目管理',
        params: {customerid: this.$route.params.customerid || ''},
        query: {customername: this.$route.query.customername || ''},
      },

      formRules: formRules,
      fileList: [],
      appTaskPackageWhitelistTagLabel: '',
      dataModel: {
        customerid: this.$route.params.customerid || '',
        name: '',
        number: '',
        budget: 0,
        ticket_predict: '',
        gross_rate_predict: '',
        starttime: '',
        endtime: '',
        detail: '',
        type: 1,
        receiver: [],
        bu_approver: 0,
        executive_budget: '',
        attached_file: [],
        predict_frontend_cost: 0,
        predict_label_cost: 0,
        second_approver: 0,
        first_approver: 0,
        finance_approver: 0,
        project_level: '',
        project_category: '',
        target_complete_rate: '',
        target_market_num: '',
        execute_rate: '',
        bd: 0,
        bu: 0,
        review_group: '',
        distribute_type: '',
        predict_backend_cost: 0,
        predict_others_cost: 0,
        is_first_execute: 0,
        business_process_completed: 1,
        annual_cooperation_scale: '',
        annual_cooperation_times: '',
        contract_no: '',
        special_approve_reason: '',
        enable_release_notice: '0',
        app_task_package_display: taskPackageConsts.DISPLAY_NONE,
        app_task_package_title: '',
        app_task_package_whitelist_tags: [],
      },
      reason: '',
      status: 0,
      inLoading: {
        submit: false,
      },
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',
      initiator_name: '',
      activeNames: ['1', '2', '3']
    }
  },
  created () {
    this.promiseUsers = new Promise((resolve, reject) => {
      if (this.$route.params.id) {
        this.id = this.$route.params.id
        this.setForm().then((data) => {
          this.setRemoteSelectAdminUsers().then(resolve, reject)
        })
      }
    })
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    onLoad () {
      this.setCustomer()
    },
    setRemoteSelectAdminUsers () {
      let data = this.dataModel
      let params = [
        data.first_approver, data.second_approver, data.finance_approver, data.bd, data.bu
      ].filter((item) => item !== 0)
      params = params.concat(data.receiver).map((item) => item * 1)
      params = _.uniq(params)
      return request.common('getPlatformUsersIndex', {adminuser_ids: params})
    },
    getRemoteSelectAdminUsers ({id}) {
      return new Promise((resolve, reject) => {
        this.promiseUsers.then(({data}) => {
          if (data) {
            const user = _.find(data.data, {id})
            resolve({
              data: user
            })
          } else {}
        })
      })
    },
    setPreviousTable (from) {
      if (from.name) {
        this.parentPage = Object.assign({}, from)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm () {
      return request.common('getProjectDetail', {id: this.id}).then(({data}) => {
        this.initiator_name = data.initiator_name || ''
        this.dataModel = data
        this.fileList = this.dataModel.attached_file

        this.dataModel.starttime = filter.formatDate(data.starttime * 1000)
        this.dataModel.endtime = filter.formatDate(data.endtime * 1000)
        this.dataModel.type *= 1
        this.dataModel.project_level *= 1
        this.dataModel.app_task_package_display = parseInt(
          data.app_task_package_display || taskPackageConsts.DISPLAY_NONE,
          10
        )
        this.dataModel.app_task_package_title = data.app_task_package_title || ''
        this.dataModel.app_task_package_whitelist_tags = Array.isArray(data.app_task_package_whitelist_tags)
          // remote-select / query_tag 的 id 为字符串，需与 option value 类型一致才能显示 label
          ? data.app_task_package_whitelist_tags.map((id) => String(id))
          : []
        this.status = data.status
        this.loadAppTaskPackageWhitelistTagNames()
      })
    },
    loadAppTaskPackageWhitelistTagNames () {
      const ids = this.dataModel.app_task_package_whitelist_tags || []
      if (!ids.length) {
        this.appTaskPackageWhitelistTagLabel = ''
        return Promise.resolve()
      }
      return request.common('getUserTagTable', {tag_id: ids}).then(({data}) => {
        const list = (data && data.data) ? data.data : (Array.isArray(data) ? data : [])
        this.appTaskPackageWhitelistTagLabel = list.map((t) => t.tagname || t.name || t.id).join('、')
      }).catch(() => {
        this.appTaskPackageWhitelistTagLabel = ids.join(', ')
      })
    },
    pass () {
      let status = this.dataModel.status * 1
      if (status === this.statusEnum.REVIEW) {
        this.updateStatus(this.statusEnum.BU_APPROVE)
      } else if (status === this.statusEnum.BU_APPROVE) {
        this.updateStatus(this.statusEnum.FIRST_APPROVE)
      } else if (status === this.statusEnum.FIRST_APPROVE) {
        this.updateStatus(this.statusEnum.SECOND_APPROVE)
      } else if (status === this.statusEnum.SECOND_APPROVE) {
        this.updateStatus(this.statusEnum.ACHIEVEMENT)
      }
    },
    reject () {
      this.updateStatus(this.statusEnum.REJECTED, {is_reject: true})
    },
    updateStatus (status, params) {
      let id = this.id
      request.common('updateProjectStatus', {
        id,
        status,
        number: this.dataModel.number,
        contract_no: this.dataModel.contract_no,
        special_approve_reason: this.dataModel.special_approve_reason,
        attached_file: this.dataModel.attached_file,
        reason: this.reason,
        ...params
      }).then(_ => {
        this.$message.success('设置成功')
        // this.$router.push({path: '/project/table/' + this.dataModel.customerid})
        this.$router.back(-1)
      })
    },
    // 验证结束时间
    endtimeValidator (rule, value, callback) {
      if (Date.parse(this.dataModel.endtime) <= Date.parse(this.dataModel.starttime)) {
        callback(new Error('结束时间必须晚于开始时间'))
      } else {
        callback()
      }
    },
    setCustomer () {
      request.common('getCustomerDetail', {id: this.$route.params.customerid}).then(({data}) => {
        this.customer = data
      })
    },
    getUploadRef (index) {
      return `upload${index}`
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList) {
      let isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, fileList)
    },
    onUploadFile (file, fileList) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadProjectFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        } else if (file.name.substr(-4).toLowerCase() === '.xlsx') {
          type = 'xlsx'
        }
        if (index > -1) {
          this.dataModel.attached_file[index] = {name: file.name, url: data, type: type}
          this.fileList[index] = {name: file.name, url: data, type: type}
        }
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        this.dataModel.attached_file.splice(index, 1)
      }
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(filter.ossHost(item.url))
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      item.url = filter.ossHost(item.url)
      if (item.type === 'pdf') {
        window.open(item.url)
      } else if (item.type === 'eml') {
        this.attach_file_url = item.url
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}

</script>



<style lang="scss"
       scoped>
.app-task-package-view-item {
  >>> .el-form-item__label {
    white-space: normal;
    line-height: 20px;
    padding-top: 6px;
    color: #606266;
  }

  >>> .el-form-item__content {
    line-height: 32px;
    min-height: 32px;
  }
}

.app-task-package-view-text {
  display: inline-block;
  color: #303133;
  font-size: 14px;
  line-height: 32px;
  word-break: break-all;

  &.is-muted {
    color: #c0c4cc;
  }
}

.app-task-package-view-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  min-height: 32px;
}

.app-task-package-view-tag {
  margin: 0;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}
</style>



// WEBPACK FOOTER //
// src/views/customer-project/pages/CustomerProjectApproveDetail.vue